import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { TextBody } from "../info/TextBody";
import { usePublicCityLinks } from "../../lib/werkgebied";

// Gepubliceerde plaatspagina's (Beheer → Werkgebied); kernplaatsen eerst.
export const AboutArea = ({ block }) => {
  const cities = [...usePublicCityLinks()].sort((a, b) => Number(!!b.priority) - Number(!!a.priority));
  return (
    <div className="grid gap-10 lg:grid-cols-12 lg:gap-14" data-testid="about-area">
      <div className="lg:col-span-6">
        <TextBody text={block.body} />
        <Link to="/werkgebied" className="mt-6 inline-flex items-center gap-1.5 text-[15px] font-semibold text-maas hover:underline" data-testid="about-area-link">Bekijk ons werkgebied <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
      </div>
      <ul className="flex flex-wrap content-start gap-2 lg:col-span-6" data-testid="about-area-cities">
        {cities.map((c) => (
          <li key={c.slug}>
            <Link to={`/kunststof-kozijnen-${c.slug}`} data-testid={`about-city-${c.slug}`}
              className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-[14px] font-semibold transition-colors ${c.priority ? "bg-ink text-white hover:bg-maas" : "bg-white text-ink ring-1 ring-slate-200 hover:text-maas hover:ring-maas"}`}>
              <MapPin className="h-3.5 w-3.5" aria-hidden="true" /> {c.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
